/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VariableSettingErrorDto { 
    field?: string;
    code?: string;
    parameters?: { [key: string]: object; };
    message?: string;
    variable_id?: string;
}

